import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { ScrollArea } from "./ui/scroll-area";

export default function HouseRulesModal({ open, onOpenChange, onAgree }) {
  const [rules, setRules] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (open) api.get("/house-rules").then((r) => setRules(r.data));
  }, [open]);

  const confirm = () => {
    if (!checked) return;
    onAgree?.(rules?.version || "v1.0");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#F8F9FE] max-w-2xl">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">
            KSB House Rules <span className="text-sm text-[#5B6478] font-normal">({rules?.version || "v1.1"})</span>
          </DialogTitle>
        </DialogHeader>
        <ScrollArea className="h-[420px] rounded-md border border-[#E4E7F5] bg-white p-5">
          <div className="prose prose-sm max-w-none whitespace-pre-wrap font-sans leading-relaxed text-[#0F1E4B]">
            {rules ? rules.content : "Loading..."}
          </div>
        </ScrollArea>
        <label className="flex items-start gap-3 mt-2 text-sm">
          <input
            data-testid="house-rules-checkbox"
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            className="mt-0.5"
          />
          <span>
            I have read, understood and agree to the KSB House Rules and Code of Conduct. I understand that violation may lead to suspension or permanent removal from the KSB pool.
          </span>
        </label>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="border-[#E4E7F5]">Cancel</Button>
          <Button
            data-testid="house-rules-agree"
            disabled={!checked}
            onClick={confirm}
            className="bg-[#1E3A8A] hover:bg-[#2E4FB8] text-[#F8F9FE]"
          >
            I Agree & Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
